// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__wVs1S","box":"WorkspacesBox_box__248Z-","node":"WorkspacesBox_node__1LRQL"};